<template>
  <svg :width="computedSize" :height="computedSize" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 16L18.5 12L14.5 8" :stroke="color ?? 'currentColor'" stroke-width="1.5" />
    <path d="M18.5 12L5.5 12" :stroke="color ?? 'currentColor'" stroke-width="1.5" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  color?: 'white' | 'black'
  size?: 'small' | 'medium' | 'large' | number
}>()

const computedSize = computed(() => {
  if (typeof props.size === 'number') {
    return props.size
  }

  switch (props.size) {
    case 'small':
      return '16'
    case 'medium':
      return '24'
    case 'large':
      return '32'
    default:
      return '24'
  }
})
</script>
